enum WorkflowTypeEnum {
    TACH = 1,
    AbonoLegal = 2,
    GestaoAtividades = 3,
    HoraExtra = 4,
}

const WorkflowTypeEnumLabel = new Map<WorkflowTypeEnum, string>([
    [WorkflowTypeEnum.TACH, "TACH"],
    [WorkflowTypeEnum.AbonoLegal, "Abono Legal"],
    [WorkflowTypeEnum.GestaoAtividades, "Gestão de Atividades"],
    [WorkflowTypeEnum.HoraExtra, "Hora Letiva RE"],
]);

export { WorkflowTypeEnum, WorkflowTypeEnumLabel };
